import React from 'react';
import {labels} from '../../../../../../../util/utils';
import Icon from '../../../../../BaseComponentWrappers/MotifIcon';
import {IconoirStatsDownSquare} from '@ey-xd/motif-icon';

export const displayAnalyticsIcon = (showIcon, onAnalyticsIconClick, hasHelixProjects) => {
	if (showIcon) {
		return (
			<span
				className={`analyticsIcons ${!hasHelixProjects ? 'disabled' : 'enabled'}`}
				title={hasHelixProjects ? labels.analytics : labels.analyticsIconDisabled}
				onClick={onAnalyticsIconClick}
			>
				<Icon src={IconoirStatsDownSquare} title={hasHelixProjects ? labels.analytics : labels.analyticsIconDisabled} />
			</span>
		);
	} else {
		return <span className="noDataDash">{'-'}</span>;
	}
};
